import React,{useEffect,useState}from'react';
async function api(u,o){const r=await fetch(u,{credentials:'include',headers:{'Content-Type':'application/json'},...o}),j=await r.json().catch(()=>({}));if(!r.ok)throw Error(j.error||'Request failed');return j}
const badge={overdue:'bg-red-100 text-red-800',due_soon:'bg-amber-100 text-amber-800',current:'bg-emerald-100 text-emerald-800',complete:'bg-slate-100 text-slate-600'};
const label={overdue:'Overdue',due_soon:'Due Soon',current:'Current',complete:'Complete'};
export default function AdminDementiaTraining(){
  const[list,setList]=useState([]),[summary,setSummary]=useState({}),[employees,setEmployees]=useState([]);
  const[f,setF]=useState({training_type:'initial'}),[e,setE]=useState('');
  const[completing,setCompleting]=useState(null);
  const[ext,setExt]=useState(null),[m,setM]=useState('');
  const saveExt=async()=>{
    try{const r=await api('/api/extensions/dementia',{method:'POST',body:JSON.stringify({record_id:ext.id,new_due_date:ext.date,reason:ext.reason})});
      setExt(null);setE('');setM('Due date changed to '+r.new_due+'.'+(r.warning?' '+r.warning:''));load()}
    catch(x){setE(x.message)}
  };
  const load=()=>Promise.all([api('/api/dhhs-compliance/dementia-training'),api('/api/dhhs-compliance/dementia-training/summary'),api('/api/employees')])
    .then(([a,b,c])=>{setList(a);setSummary(b);setEmployees(c)}).catch(x=>setE(x.message));
  useEffect(()=>{load()},[]);
  const add=async()=>{
    if(!f.employee_id||!f.hire_date){setE('Employee and hire date are required.');return}
    try{await api('/api/dhhs-compliance/dementia-training',{method:'POST',body:JSON.stringify(f)});setF({training_type:'initial'});setE('');load()}
    catch(x){setE(x.message)}
  };
  const complete=async(id,payload)=>{
    try{await api(`/api/dhhs-compliance/dementia-training/${id}/complete`,{method:'POST',body:JSON.stringify(payload)});setCompleting(null);load()}
    catch(x){setE(x.message)}
  };
  return <div className="p-5 space-y-5">
    <header>
      <h1 className="text-3xl font-black">Dementia Training Tracking</h1>
      <p className="text-slate-600">Initial training (6 hrs, within 90 days of hire) and continuing education (4 hrs/calendar year), per NH DHHS requirements.</p>
    </header>
    {e&&<div className="bg-red-50 p-3 rounded-lg text-red-800">{e}</div>}
    {m&&<div className="bg-emerald-50 p-3 rounded-lg text-emerald-800">{m}</div>}
    {ext&&<section className="rounded-2xl border-2 border-amber-400 bg-white p-4">
      <h2 className="text-xl font-black">Extend due date</h2>
      <p className="text-sm text-slate-600">{ext.name}. Current due date: {ext.old||'none'}.</p>
      <p className="mt-1 text-sm text-amber-800">Initial dementia training is due 90 days from the hire date under NH rules. A later date is saved with your reason, but it does not change the state deadline.</p>
      <div className="mt-3 grid gap-3 md:grid-cols-4">
        <input id="ext-date" type="date" className="border p-3" value={ext.date} onChange={x=>setExt({...ext,date:x.target.value})}/>
        <input id="ext-reason" className="border p-3 md:col-span-2" placeholder="Reason for the extension (required)" value={ext.reason} onChange={x=>setExt({...ext,reason:x.target.value})}/>
        <div className="flex gap-2"><button className="flex-1 rounded-lg bg-slate-900 px-4 py-3 font-bold text-white" onClick={saveExt}>Save</button><button className="rounded-lg border px-4 py-3 font-bold" onClick={()=>setExt(null)}>Cancel</button></div>
      </div>
    </section>}
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {['overdue','due_soon','current','complete'].map(k=>
        <div key={k} className="rounded-2xl border bg-white p-4">
          <div className="text-xs uppercase text-slate-500">{label[k]}</div>
          <div className="text-2xl font-black">{summary[k]||0}</div>
        </div>
      )}
    </div>
    <section className="rounded-2xl border bg-white p-4">
      <h2 className="text-xl font-black">Add Training Record</h2>
      <div className="mt-3 grid gap-3 md:grid-cols-4">
        <select className="border p-3" value={f.employee_id||''} onChange={x=>setF({...f,employee_id:x.target.value})}>
          <option value="">Select Employee…</option>
          {employees.map(emp=><option key={emp.employee_id} value={emp.employee_id}>{emp.first_name} {emp.last_name}</option>)}
        </select>
        <select className="border p-3" value={f.training_type} onChange={x=>setF({...f,training_type:x.target.value})}>
          <option value="initial">Initial (6 hrs, 90-day)</option>
          <option value="continuing">Continuing (4 hrs/year)</option>
        </select>
        <input type="date" className="border p-3" placeholder="Hire Date" value={f.hire_date||''} onChange={x=>setF({...f,hire_date:x.target.value})}/>
        <input type="number" className="border p-3" placeholder="Hours" value={f.hours||''} onChange={x=>setF({...f,hours:x.target.value})}/>
        <button onClick={add} className="bg-slate-900 p-3 font-bold text-white md:col-span-4 rounded-lg">Add Record</button>
      </div>
    </section>
    <section className="rounded-2xl border bg-white p-4">
      <h2 className="text-xl font-black">Training Records</h2>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left"><th>Employee</th><th>Type</th><th>Hours</th><th>Due</th><th>Status</th><th>Action</th></tr></thead>
          <tbody>
            {list.map(x=>
              <tr key={x.id} className="border-t">
                <td className="py-3 font-bold">{x.employee_name}</td>
                <td>{x.training_type==='initial'?'Initial':'Continuing'}</td>
                <td>{x.hours}</td>
                <td>{x.due_date}</td>
                <td><span className={`px-2 py-1 rounded-full text-xs font-bold ${badge[x.status]}`}>{label[x.status]}</span></td>
                <td>
                  {x.status!=='complete' && (
                    completing===x.id ? (
                      <div className="flex gap-2 items-center">
                        <label className="flex items-center gap-1 text-xs">
                          <input type="checkbox" onChange={ev=>setF(prev=>({...prev,_comp:ev.target.checked}))}/> Competency demonstrated
                        </label>
                        <button className="text-emerald-700 font-bold" onClick={()=>complete(x.id,{competency_demonstrated:f._comp,certificate_issued:true})}>Save</button>
                        <button className="text-slate-500" onClick={()=>setCompleting(null)}>Cancel</button>
                      </div>
                    ) : (
                      <><button className="text-blue-700 font-bold" onClick={()=>setCompleting(x.id)}>Mark Complete</button><button className="ml-3 text-blue-700" onClick={()=>{setExt({id:x.id,name:x.employee_name,old:x.due_date,date:x.due_date||'',reason:''});window.scrollTo(0,0)}}>Extend</button></>
                    )
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  </div>;
}
